import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axiosInstance from '../api/axiosInstance';
import socket from '../utils/WebSocket';
import { ChevronLeft } from 'lucide-react';

const Notifications = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [friendRequests, setFriendRequests] = useState({});

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axiosInstance.get('/notifications/get');
        setNotifications(response.data.data);
        setUnreadCount(response.data.data.filter((n) => !n.is_read).length);

        response.data.data.forEach(async (notification) => {
          if (notification.notification_text.includes("sent you a close friends request")) {
            await checkFriendRequestStatus(notification.entity_id);
          }
        });
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    fetchNotifications();

    socket.on('notification', (newNotification) => {
      setNotifications((prev) => [newNotification, ...prev]);
      setUnreadCount((prev) => prev + 1);

      if (newNotification.notification_text.includes("sent you a close friends request")) {
        checkFriendRequestStatus(newNotification.entity_id);
      }
    });

    return () => {
      socket.off('notification');
    };
  }, []);

  const markAsRead = async (notificationId, tableName, entity_id, sender_id) => {
    try {
      await axiosInstance.patch(`/notifications/${notificationId}`);
      setNotifications((prev) =>
        prev.map((n) =>
          n.notification_id === notificationId ? { ...n, is_read: true } : n
        )
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));

      if (tableName == 'user_ratings') {
        navigate(`/profile/${sender_id}`);
      }
      else if (tableName.includes('flash')) {
        navigate(`/flash/${entity_id}`);
      }
      else if (tableName.includes('trippin')) {
        navigate(`/trippins/${entity_id}`);
      }
      else if (tableName.includes('chat')) {
        navigate(`/chat/${entity_id}`);
      }

    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const checkFriendRequestStatus = async (entity_id) => {
    try {
      const response = await axiosInstance.get(`/user-ratings/${entity_id}`);
      console.log(response);
      if (response.data.status === "pending") {
        setFriendRequests((prev) => ({ ...prev, [entity_id]: "pending" }));
      }
    } catch (error) {
      console.error("Error checking friend request status:", error);
    }
  };

  const handleResponse = async (entity_id, status) => {
    try {
      await axiosInstance.patch(`/user-ratings/${entity_id}`, { status });

      setFriendRequests((prev) => ({ ...prev, [entity_id]: status }));

      setNotifications((prev) =>
        prev.map((n) =>
          n.entity_id === entity_id ? { ...n, is_read: true } : n
        )
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Error updating friend request status:", error);
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-darkBackground text-black dark:text-white">
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ChevronLeft className="w-8 h-8" /> 
        </button>
        <h1 className="top-title">Notifications</h1>
      </div>

      <div className="max-w-md mx-auto px-4 py-4">

        {/* {unreadCount > 0 && (
          <span className="inline-flex items-center rounded-full bg-blue-600 text-white text-xs font-medium px-2.5 py-1">
            Unread: {unreadCount}
          </span>
        )} */}

        <ul className="divide-y divide-gray-200 dark:divide-neutral-800">
          {notifications.map((notification) => {
            const isUnread = !notification.is_read;
            return (
              <li
                key={notification.notification_id}
                className="flex items-center justify-between gap-3 py-3 cursor-pointer"
                onClick={() =>
                  markAsRead(
                    notification.notification_id,
                    notification.entity_type,
                    notification.entity_id,
                    notification.sender_id
                  )
                }
              >
                <div className="flex min-w-0 items-center gap-3 flex-1">
                  <img
                    src={notification.profile_url || "/assets/images/default_profile.png"}
                    alt="Sender Profile"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/profile/${notification.sender_id}`);
                    }}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <span className="text-sm leading-snug">
                    <span className={isUnread ? 'font-bold' : 'font-semibold'}>
                      {notification.notification_text.split(' ')[0]}
                    </span>{" "}
                    <span className={isUnread ? 'font-bold' : ''}>
                      {notification.notification_text.split(' ').slice(1).join(' ')}
                    </span>
                  </span>
                </div>

                {notification.notification_text.includes('sent you a close friends request') &&
                friendRequests[notification.entity_id] === 'pending' && (
                  <div className="tailwind flex-shrink-0 self-center flex items-center gap-2 ml-3">
                    <button
                      className="px-3 py-1.5 rounded-md bg-mainLightColor text-white text-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleResponse(notification.entity_id, 'approved');
                      }}
                    >
                      Accept
                    </button>
                    <button
                      className="px-3 py-1.5 rounded-md bg-likeColor text-white text-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleResponse(notification.entity_id, 'declined');
                      }}
                    >
                      Reject
                    </button>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Notifications;